<template>
    <div class="slider">
        <div class="carousel">
            <carousel-slide
                v-for="(item, index) in getArticles"
                :key="index"
                :item_data="item"
                :lang="lang"
                v-show="item.style === 'active'"
            />
            <div class="slider__btn-next d-flex">
                <span class="btn-next mr-2" @click="prevPost"></span>
                <span class="btn-next btn-right" @click="nextPost"></span>
            </div>
        </div>
    </div>
</template>

<script>
import carouselSlide from './Carousel-slide'

export default {
    name: "Blog-slider",
    components: {carouselSlide},
    props: ['articles', 'lang'],

    data: () => ({
        currentSlideIndex: 0,
        interval: 5000
    }),

    mounted() {
        let vm = this;
        setInterval( function () {
            vm.nextPost()
        }, vm.interval)
    },

    computed: {
        getArticles() {
            for(let i = 0; i < this.articles.length; i++) {
                if (this.articles[i].blog_content.length > 1) {
                    this.articles[i].blog_content = this.sortLang(this.articles[i].blog_content)
                }
                if (i === this.currentSlideIndex) {
                    this.articles[i].style = 'active';
                } else {
                    this.articles[i].style = 'hidden';
                }
            }
            return this.articles;
        }
    },

    methods: {
        sortLang (article) {
            let articleLang = article.find(article => article.lang === this.lang)
            if (typeof articleLang === 'undefined') {
                articleLang = article.find(article => article.lang === 'en')
            }
            return articleLang
        },

      prevPost () {
        if (this.currentSlideIndex > 0) {
            this.currentSlideIndex--;
        } else {
            this.currentSlideIndex = this.articles.length - 1;
        }
      },

      nextPost () {
        if (this.currentSlideIndex < this.articles.length - 1) {
            this.currentSlideIndex++;
        } else {
            this.currentSlideIndex = 0;
        }
      }
    },
}
</script>

<style lang="css">
.slider{height:100%; max-width: 100%; overflow: hidden;}
.carousel{display: flex; height: 100%; position: relative;}
.slider__btn-next{position: absolute; right: 30px; bottom: 15px; z-index: 1;}
.btn-next{background-color: #62B2D8; height: 30px; width: 30px; background-image: url("/img/arrow1.png"); background-repeat: no-repeat; background-position: center center; }
.btn-next:hover{box-shadow:0 2.8px 2.2px rgba(0, 0, 0, 0.034), 0 6.7px 5.3px rgba(0, 0, 0, 0.048), 0 12.5px 10px rgba(0, 0, 0, 0.06), 0 22.3px 17.9px rgba(0, 0, 0, 0.072), 0 41.8px 33.4px rgba(0, 0, 0, 0.086), 0 100px 80px rgba(0, 0, 0, 0.12);}
.btn-right{transform: rotate(180deg);}
@media screen and (min-width: 1240px) {
    .slider{height: 620px;}
}
@media screen and (max-width: 1239px) {
    .slider{height: 500px;}
}
@media screen and (max-width: 991px) {
    .slider{height: 440px;}
    .slide-body{padding: 20px 20px;}
}
@media screen and (max-width: 768px) {
    .slider{height: 540px;}
    .slide-body{height:30%;left: 0; right: 0; min-width: 100%;  box-shadow: inset 0 0 1px black; }
}
@media screen and (max-width: 500px) {
    .slider{height: 440px;}
    .slide-body{height:40%;}
}

.slide-enter-active, .slide-leave-active {
    transition: all 0.5s;
}

.slide-enter, .slide-leave-to {
    opacity: 0;
    transform: translateX(-300);
}
</style>

